import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  background-color: transparent;
  width: 100%;
  max-width: 1200px;
  padding: 20px 32px 8px;
  box-sizing: border-box;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 16px 16px 4px;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const RightContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
`;

export const Subtitle = styled.span`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #9a8e84;
  letter-spacing: 0.03em;
`;

export const Title = styled.span`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 26px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.03em;
  margin-top: 4px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const Image = styled.img`
  height: 48px;
  width: 48px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e8e0d6;
  cursor: pointer;
  transition: opacity 0.15s;
  &:hover { opacity: 0.85; }

  @media (max-width: 768px) {
    height: 38px;
    width: 38px;
  }
`;
